import React from 'react';
import Footer from './Footer';

const ContactPage: React.FC = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-6 text-center">
          Contact <span className="text-primary-600">Misu Capital</span>
        </h1>

        <p className="text-gray-600 text-center mb-8">
          We're here to help you connect with the right financial advisor. Reach out via the details below.
        </p>

        <div className="space-y-6 text-gray-700">
          <div className="flex items-center space-x-4">
            <span className="text-xl">📞</span>
            <span className="text-lg font-medium">+91 7470818049</span>
          </div>

          <div className="flex items-center space-x-4">
            <span className="text-xl">📧</span>
            <span className="text-lg font-medium">misu.capital@gmail.com</span>
          </div>
        </div>

        <div className="mt-10 border-t pt-8 text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Start a Conversation Instantly
          </h2>
          <a
            href="https://wa.me/917470818049?text=Hi!%20I%E2%80%99m%20interested%20in%20getting%20started%20with%20Misu%20Capital%E2%80%99s%20financial%20advisory%20services.%20Can%20you%20please%20connect%20me%20with%20a%20verified%20advisor%20or%20guide%20me%20on%20the%20next%20steps%3F%20Thank%20you!"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-green-500 text-white px-6 py-3 rounded-md hover:bg-green-600 transition text-lg font-medium"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp Logo"
              className="w-6 h-6"
            />
            Message Us on WhatsApp
          </a>
        </div>

        {/* New Advisor Application Card */}
        <div className="mt-10 border-t pt-8 text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Want to Become an Advisor?
          </h2>
          <p className="text-gray-600 mb-6">
            If you're a certified financial expert and would like to join Misu Capital as an advisor, please apply using the form below.
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSc0KyVzJmJ-BOvbQtl0AGLAlp75TqI40KBuP0zEVpM7eFs_Gw/viewform?usp=dialog" // Replace with your actual Google Form URL
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition text-lg font-medium"
          >
          Join us as an Advisor
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ContactPage;
